/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';
import './index.scss';

const Button = ({ children, type, isDisabled, className, ...propObject }) => {
  const classRoot = 'button';
  const classes = [classRoot];
  const props = propObject;
  const { theme } = props;

  if (theme) {
    delete props.theme;
    classes.push(`${classRoot}--${theme}`);
  }

  return (
    <button
      className={`${classes.join(' ')} ${className}`}
      type={type}
      disabled={isDisabled}
      {...props}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['', 'inverted', 'inline-link', 'ghost']),
};

Button.defaultProps = {
  type: 'button',
  isDisabled: false,
  theme: undefined,
  className: '',
};

export default Button;
